/* e-Ko Skin – cadou automat in cos
 * Adauga automat Heimish All Clean Balm Mandarin (gratuit) cand valoarea cosului,
 * dupa reducerile vizibile in cos si fara cadou, ajunge la 150 RON.
 * Il scoate automat daca valoarea scade sub prag.
 * Gratuitatea e garantata de reducerea automata Shopify
 * "Cadou: Heimish All Clean Balm la comenzi de 150 RON".
 */
(function () {
  'use strict';

  var CFG = {
    variantId: 55192742854990,
    threshold: 15000, // in bani: 150,00 RON
    propKey: 'Cadou',
    propValue: 'Gratuit la comenzi de minimum 150 RON'
  };

  var nativeFetch = window.fetch.bind(window);
  var busy = false;
  var pending = false;
  var timer = null;
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;

  function jsonHeaders() {
    return { 'Content-Type': 'application/json', Accept: 'application/json' };
  }

  function isGift(item) {
    return item.variant_id === CFG.variantId && item.properties && item.properties[CFG.propKey];
  }

  function refreshUI() {
    // Evenimentul nativ al temei: reincarca cosul lateral, pagina de cos si numarul de pe iconita cosului
    if (document.querySelector('cart-form')) {
      document.dispatchEvent(new CustomEvent('on:cart:change', { bubbles: true }));
    } else if (/^\/cart\/?$/.test(window.location.pathname)) {
      window.location.reload();
    }
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(sync, 400);
  }

  function sync() {
    if (busy) { pending = true; return; }
    busy = true;

    nativeFetch('/cart.js', { credentials: 'same-origin', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var gifts = cart.items.filter(isGift);
        var paid = cart.items.filter(function (i) { return !isGift(i); });
        var giftTotal = gifts.reduce(function (s, i) { return s + i.final_line_price; }, 0);
        var eligible = cart.total_price - giftTotal;
        var updates = null;
        var request = null;

        if (paid.length > 0 && eligible >= CFG.threshold) {
          if (gifts.length === 0) {
            var props = {};
            props[CFG.propKey] = CFG.propValue;
            request = nativeFetch('/cart/add.js', {
              method: 'POST',
              credentials: 'same-origin',
              headers: jsonHeaders(),
              body: JSON.stringify({ items: [{ id: CFG.variantId, quantity: 1, properties: props }] })
            });
          } else if (gifts.length > 1 || gifts[0].quantity !== 1) {
            updates = {};
            gifts.forEach(function (g, idx) { updates[g.key] = idx === 0 ? 1 : 0; });
          }
        } else if (gifts.length > 0) {
          updates = {};
          gifts.forEach(function (g) { updates[g.key] = 0; });
        }

        if (updates) {
          request = nativeFetch('/cart/update.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: jsonHeaders(),
            body: JSON.stringify({ updates: updates })
          });
        }

        if (request) {
          return request.then(function () { refreshUI(); });
        }
      })
      .catch(function () { /* in caz de eroare, cosul ramane neschimbat */ })
      .then(function () {
        busy = false;
        if (pending) { pending = false; schedule(); }
      });
  }

  // Reactioneaza la orice modificare a cosului facuta de tema (fetch)
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (CART_WRITE.test(url)) {
      p.then(function () { schedule(); }, function () {});
    }
    return p;
  };

  // ...si prin XMLHttpRequest (aplicatii mai vechi)
  var origOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(String(url))) {
      this.addEventListener('load', schedule);
    }
    return origOpen.apply(this, arguments);
  };

  // Formulare clasice trimise catre /cart (pagina de cos)
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('pageshow', function (e) { if (e.persisted) schedule(); });
})();
